import type { PeriodFormat } from './types'

export function periodCount(format: PeriodFormat): number {
  return format === 'quarters' ? 4 : 2
}

export function periodLabel(format: PeriodFormat, period: number): string {
  return format === 'quarters' ? `Q${period}` : `H${period}`
}

export function periodList(format: PeriodFormat): number[] {
  return Array.from({ length: periodCount(format) }, (_, i) => i + 1)
}
